import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "we_upload_container"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("选择文件")
const _hoisted_3 = { class: "files_container" }
const _hoisted_4 = { class: "file_content_container" }
const _hoisted_5 = { class: "file_name" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("选择文件")

import { computed, ref, unref, watch } from 'vue';
  import { cloneDeep } from 'lodash-es';
  import { isEmptyData, getFileIconName } from '@/utils/common';
  import { Form } from 'ant-design-vue';
  interface ICustomRequest {
    action: string;
    data: Recordable;
    file: File;
    filename: string;
    headers: Recordable;
    onError: Fn;
    onProgress: Fn;
    onSuccess: Fn;
  }
  interface IFile {
    name: string;
    id?: number;
    base64_data?: string;
    path?: string;
  }
  interface IProps {
    value: IFile | IFile[];
    accept?: string;
    disabled: boolean;
    multiple: boolean;
    show_file_list?: boolean;
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    value: { default: () => [] },
    accept: { default: '' },
    disabled: { default: false },
    multiple: null,
    show_file_list: { default: true }
  },
  emits: ['update:value', 'change', 'input'],
  setup(__props: any, { emit }) {

const props = __props as { value: IFile | IFile[], accept: string, disabled: boolean, multiple: boolean, show_file_list: boolean }

  

  const formItemContext = Form.useInjectFormItemContext();

  
  const maxCount = computed(() => {
    if (props.multiple) {
      return 10;
    } else {
      return 1;
    }
  });
  const fileList = ref<IFile[]>([]);
  watch(
    props.value,
    (val) => {
      if (isEmptyData(val)) {
        fileList.value = [];
      } else if (!Array.isArray(val)) {
        fileList.value = [val];
      } else {
        fileList.value = val;
      }
    },
    { immediate: true }
  );
  function emitChange() {
    const files = cloneDeep(unref(fileList));
    if (props.multiple) {
      emit('update:value', files);
      emit('change', files);
      emit('input', files);
      formItemContext.onFieldChange();
    } else {
      emit('update:value', files[0]);
      emit('change', files[0]);
      emit('input', files[0]);
      formItemContext.onFieldChange();
    }
  }
  function deleteFile(index: number) {
    unref(fileList).splice(index, 1);
    emitChange();
  }
  // base64上传
  function hwSelectFile(options: ICustomRequest) {
    const file = options.file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function (e) {
      if (props.multiple) {
        fileList.value.push({ name: file.name, base64_data: e.target?.result as string });
      } else {
        fileList.value.splice(0, 1, { name: file.name, base64_data: e.target?.result as string });
      }
      emitChange();
      options.onSuccess(true);
    };
  }

  function handleChange() {
    return false;
  }

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (__props.show_file_list)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_a_upload, {
          onChange: handleChange,
          multiple: __props.multiple,
          accept: __props.accept,
          customRequest: hwSelectFile,
          "max-count": _unref(maxCount),
          showUploadList: false,
          "file-list": fileList.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              ghost: "",
              disabled: __props.disabled
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["multiple", "accept", "max-count", "file-list"]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileList.value, (file, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: file.name
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_svg_icon, {
                  "icon-name": _unref(getFileIconName)(file.name)
                }, null, 8, ["icon-name"]),
                _createElementVNode("div", _hoisted_5, _toDisplayString(file.name), 1),
                _createVNode(_component_svg_icon, {
                  "icon-name": "DeleteOutlined",
                  class: "file_delete_icon",
                  onClick: ($event: any) => (deleteFile(index))
                }, null, 8, ["onClick"])
              ])
            ]))
          }), 128))
        ])
      ]))
    : (_openBlock(), _createElementBlock("span", _hoisted_6, [
        _createVNode(_component_a_upload, {
          multiple: __props.multiple,
          accept: __props.accept,
          customRequest: hwSelectFile,
          showUploadList: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              ghost: "",
              disabled: __props.disabled
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["multiple", "accept"])
      ]))
}
}

})